export const KeysOfSymptomPriorityForLanguage = [
    'name',
    'categoryName',
    'question',
    'information',
    'link',
    'careTips',
    'toolTips',
];
